export enum CompanyType {
  SourceSite = 'Source Site',
  ReceivingSite = 'Receiving Site',
  QualifiedPerson = 'Qualified Person',
  ThirdParty = 'ThirdParty'
}

export interface CompanyInformation {
  companyName: string;
  postalCode: string;
  address: string;
  province: string;
  municipality: string;
  city: string;
  companyPhone: string;
  extension: string;
}

export interface SourceSiteInformation {
  sourceSiteName: string;
  postalCode: string;
  address: string;
  province: string;
  municipality: string;
  city: string;
}
export interface ReceivingSiteInformation {
  receivingSiteName: string;
  receivingSiteRegistration: string;
  postalCode: string;
  address: string;
  province: string;
  municipality: string;
  city: string;
  companyPhone: string;
  extension: string;
  isThirdPartyQPRequired: boolean;
  isWeightScaleAvailable: boolean;
  isPubliclyVisible: boolean;
  acceptedSoilTypes: string;
  siteClassification: string;
  pricing: string;
}
export interface ContactInformation {
  fullName: string;
  email: string;
  phone: string;
  extension: string;
  isBillingSame: boolean;
  billingFullName: string;
  billingEmail: string;
  billingPhone: string;
  billingExtension: string;
}
export class Registration {
  companyType: CompanyType;
  companyInfo: CompanyInformation;
  sourceSiteInfo: SourceSiteInformation[];
  receivingSite: ReceivingSiteInformation[];
  contactInfo: ContactInformation;
}
